/**
 * Whether the current session belongs to an internal user (Vibrant staff), as opposed to
 * an external provider.
 *
 * va-portal gates its equivalent bar (InternalLoginUserDisplay.vue) on a localStorage
 * `isInternalLogin` flag set by its "log in as a customer" flow. This app has no such
 * flow and never sets that flag, so we derive the same thing from the server-provided
 * userInfo instead — which is also more robust, since it survives refreshes and
 * cross-portal switches rather than depending on a client-side flag that gets cleared.
 *
 * Shared by InternalUserInfoBar.vue (renders the bar) and Layout.vue (reserves its
 * height in --nav-height) so the two can't disagree about whether the bar is showing.
 */
export function isInternalUser(userInfo) {
  return !!(userInfo?.internal_user_id || userInfo?.internal_role);
}
